import { computed, WritableComputedRef } from 'vue'
import { defineVuesticConfig, useColors } from 'vuestic-ui'

export default class VuesticTheme {
	_primary: WritableComputedRef<string>
	public static get primary() {
		return this.Instance._primary.value
	}

	_textPrimary: WritableComputedRef<string>
	public static get textPrimary() {
		try {
			return this.Instance._textPrimary.value
		} catch {
			return this.getConfig().colors?.variables?.primary
		}
	}

	constructor() {
		const { setColors, getColors } = useColors()
		this._primary = computed({
			get() {
				return getColors().primary
			},
			set(value) {
				setColors({ primary: value })
			}
		})
		this._textPrimary = computed({
			get() {
				return getColors().primary
			},
			set(value) {
				setColors({ primary: value })
			}
		})
	}

	private static _Instance: VuesticTheme

	public static get Instance() {
		return this._Instance || (this._Instance = new VuesticTheme())
	}

	public static applyTheme() {
		const config = this.getConfig()
		this.Instance._primary.value = config.colors.variables.primary!
	}

	public static getColors() {
		const { getColors } = useColors()
		return getColors()
	}

	public static getConfig() {
		const config = defineVuesticConfig({
			colors: {
				variables: {
					/* Paleta moderna (base). El modo oscuro se ajusta vía `setColors` en runtime. */
					primary: '#062342',
					secondary: '#071426',
					info: '#24c8ff',
					success: '#2A7A5B',
					warning: '#FFAA00',
					danger: '#B21F2E'
				}
			},
			breakpoint: {
				enabled: false
			}
		})
		return config
	}
}
